// This route is used for all pages that need to be protected by a password.

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      rest.loggedIn
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )}
  />
);


function mapStateToProps(state) {
  return { loggedIn: state.users.currentUserId && sessionStorage.jwt };
}

export default connect(
  mapStateToProps,
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.js